import Navbar from '../../components/feature/Navbar';
import HeroSection from '../../components/feature/HeroSection';
import ServicesSection from '../../components/feature/ServicesSection';
import FeaturesGrid from '../../components/feature/FeaturesGrid';
import TestimonialsSection from '../../components/feature/TestimonialsSection';
import AboutSection from '../../components/feature/AboutSection';
import CTASection from '../../components/feature/CTASection';
import Footer from '../../components/feature/Footer';
import { useSEO } from '../../hooks/useSEO';
import { SchemaMarkup } from '../../components/SEOHead';

const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: 'Anthony Sánchez Couture',
  description: 'Atelier de alta costura artesanal en Barcelona. Vestidos de gala, bordados en oro y arreglos profesionales desde 2017.',
  url: 'https://anthonysanchezc.com',
  telephone: '+34 625 46 34 20',
  email: 'anthosanchez3108@gmail.com',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Rambla de Catalunya, 85, Principal - 2',
    addressLocality: 'Barcelona',
    addressRegion: 'Cataluña',
    postalCode: '08008',
    addressCountry: 'ES',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 41.3895,
    longitude: 2.1650,
  },
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '10:00',
      closes: '19:00',
    },
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Saturday'],
      opens: '10:00',
      closes: '14:00',
    },
  ],
  priceRange: '€€€€',
  image: 'https://readdy.ai/api/search-image?query=elegant-haute-couture-gown-on-mannequin-in-minimalist-architectural-studio-soft-natural-lighting-black-and-white-editorial-photography-luxury-fashion-grain-texture-monochrome&width=1920&height=1080&seq=10&orientation=landscape',
  sameAs: [
    'https://www.instagram.com/anthony_sanchez_couture',
    'https://www.tiktok.com/@anthony_sanchez_couture',
    'https://www.airbnb.es/users/profile/1715772313040186220',
  ],
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Anthony Sánchez Couture',
  url: 'https://anthonysanchezc.com',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://anthonysanchezc.com/blog?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  useSEO({
    title: 'Anthony Sánchez Couture | Alta Costura Barcelona | Vestidos de Gala & Arreglos',
    description: 'Atelier de alta costura artesanal en Barcelona. Vestidos de gala a medida, bordados en oro y arreglos profesionales de prêt-à-porter. Reserva cita en el Eixample.',
    keywords: 'alta costura Barcelona, haute couture, vestidos gala, bordados oro, arreglos ropa, diseñador moda, Eixample, Anthony Sánchez',
    canonical: '/',
    ogTitle: 'Anthony Sánchez Couture — Alta Costura Barcelona',
    ogDescription: 'Vestidos de gala a medida y arreglos profesionales en el corazón de Barcelona. Artesanía exclusiva desde 2017.',
    ogType: 'website',
  });

  return (
    <div className="min-h-screen bg-white">
      <SchemaMarkup schema={localBusinessSchema} />
      <SchemaMarkup schema={websiteSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <ServicesSection />
        <FeaturesGrid />
        <TestimonialsSection />
        <AboutSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
